'use strict';

module.exports = function first(fn) {
  if (typeof fn === 'function') {
    for (var i = 0, length = this.items.length; i < length; i += 1) {
      var item = this.items[i];
      if (fn(item)) {
        return item;
      }
    }
  }

  return this.items[0];
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/first.js
// module id = 1221
// module chunks = 2